import { Option } from '../common/OptionInput';
import { Alert } from "reactstrap";

export const LinkEmail = ({ link, onLinkChange, onTypeChange, type, error }) => {
    return (
        <Option
            id="linkEmail"
            checked={type}
            onChange={onTypeChange}
            text="Link to an email address:"
            value="email"
            name="link"
        >
            <div style={{ width: "100%" }}>
                <input
                    className={error == true ? "errorLink" : " "}
                    onChange={onLinkChange}
                    value={type == "email" ? link : ""}
                    disabled={type !== "email"}
                    placeholder="Email address"
                    type="text"
                />
                {error == true && type == "email" && (
                    <Alert
                        color="danger"
                        className="alert"
                        fade={true}
                        style={{ textAlign: "center" }}
                    >
                        <p>Please enter a valid email address </p>
                        <p>(e.g example@flimp.net)</p>{" "}
                    </Alert>
                )}
            </div>
        </Option>
    )
}